import {Divider as DividerComponent} from '@yandex-delivery/blocks'
import clsx from 'clsx'
import React, {memo} from 'react'

import {DividerWidgetConfig} from '../types'
import * as classes from './Divider.classes'

export const DividerWidget = memo((props: DividerWidgetConfig): React.ReactElement => {
  if (props.style === 'spacer') {
    return <div style={{blockSize: props.spacer_height}} />
  }

  if (props.style === 'line_slot_margin') {
    return <DividerComponent className={clsx(classes.divider, classes.lineSlotMarginDivider)} />
  }

  return <DividerComponent className={classes.divider} />
})
